import React from 'react';
import { useTranslation } from 'react-i18next';

// import css from './ServiceRequests.module.scss';
import { navigate } from '@reach/router';
import { SubPage } from '../SubPage/SubPage';
import { WidgetProps } from '../Widget/Widget';
import { WidgetBreadcrumb } from '../../../interfaces/internal';

type ServiceRequestWidgetsProps = {
    widget: WidgetProps;
    children: React.ReactNode;
};

const handleCloseClick = async () => {
    const splittedPath = window.location.pathname.split('/');

    if (splittedPath.length >= 3) {
        await navigate(`/${splittedPath[1]}`);
    } else {
        await navigate('/');
    }
};
export const ServiceRequests: React.FC<ServiceRequestWidgetsProps> = (props: ServiceRequestWidgetsProps) => {
    const { t } = useTranslation('ServiceRequests');

    const splittedPath = window.location.pathname.split('/');
    const { widget, children } = props;

    const breadcrumb: WidgetBreadcrumb = {
        id: widget.id,
        title: widget.title,
        subPage:
            splittedPath.length >= 3
                ? {
                      icon: '',
                      title: t('Fill request form'),
                  }
                : undefined,
    };

    return (
        <SubPage breadcrumb={breadcrumb} onCloseClick={handleCloseClick} idSlug={widget.id}>
            {children}
        </SubPage>
    );
};
